import './InfoBox.css';

const InfoBox = ({ points }) => {

  // Helper to render URLs as links
  const renderWithLink = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);
    return parts.map((part, idx) =>
      urlRegex.test(part) ? (
        <a key={idx} href={part} target="_blank" rel="noopener noreferrer">{part}</a>
      ) : (
        <span key={idx}>{part}</span>
      )
    );
  };

  return (
    <div className="card text-center card-container" style={{ fontFamily: "Times New Roman, Times, serif" }}>
      <div className="card-header text-xxl" >
        {points.heading}
      </div>
      <div className="list-container">
        <ul className="list-group list-group-flush" >
          {points.details.map((point, index) => {
            // Bold the word "Openings" if present
            if (point.text.startsWith("Openings")) {
              const [first, ...rest] = point.text.split("Openings");
              return (
                <li key={index} className="list-group-item text-start">
                  <span><i className="fa-solid fa-caret-right list-point-icon"/></span>
                  <span>
                    {first}
                    <b>Openings</b>
                    {rest.join("Openings")}
                  </span>
                </li>
              );
            }
            return (
              <li key={index} className="list-group-item text-start">
                <span><i className="fa-solid fa-caret-right list-point-icon"/></span>
                <span>{renderWithLink(point.text)}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default InfoBox;
